import * as React from 'react'
import { FC, useCallback } from 'react'
import { BillToRadioCard } from '../BillToRadioCard/BillToRadioCard'
import { BillTo } from '@user/store/entityLocations'

interface Props {
  locations?: BillTo[]
  onChange?: (locationId: string, locationCode?: string) => void
  billToId?: string
}

export const BillToRadioList: FC<Props> = (props: Props) => {
  const { locations, onChange, billToId } = props

  const handleClick = useCallback(
    (locationId) => {
      if (onChange) {
        onChange(
          locationId,
          locations?.find((x) => x.id === locationId)?.number,
        )
      }
    },
    [onChange],
  )
  return locations ? (
    <>
      {locations.map((item, index) => (
        <BillToRadioCard
          checked={item.id === billToId}
          key={index}
          location={item}
          onClick={handleClick}
        />
      ))}
    </>
  ) : null
}
BillToRadioList.displayName = 'BillToRadioList'
